import { render, staticRenderFns } from "./complaints.vue?vue&type=template&id=5764afc2&"
import script from "./complaints.vue?vue&type=script&lang=js&"
export * from "./complaints.vue?vue&type=script&lang=js&"
import style0 from "./complaints.vue?vue&type=style&index=0&id=5764afc2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports